/**
 * <ry-hero>
 *
 * Hero section component (mostly CSS-only).
 *
 * Usage:
 * <ry-hero align="center">
 *   <h1>Build apps faster</h1>
 *   <p>Framework-agnostic components.</p>
 *   <ry-cluster><ry-button>Get Started</ry-button></ry-cluster>
 * </ry-hero>
 */

import { RyElement } from '../core/ry-element.js';

export class RyHero extends RyElement {}

customElements.define('ry-hero', RyHero);
